export default __webpack_public_path__ + "locales/fi/Common.json?hash=2d12f71fd89557d0b2809bf7233eb2c9";